import actions from './actions';

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  customerParametersData: [],
};


export default function authReducer(state = initState, action) {
  switch (action.type) {

    case actions.GET_CUSTOMER_PARAMERTERS:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_CUSTOMER_PARAMERTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        customerParametersData: action.payload.data,
      };
    case actions.GET_CUSTOMER_PARAMERTERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }

}
